"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScenario = getScenario;
exports.actionSetScenarioTemplate = void 0;

var _scenario = require("../normalizers/scenario");

var _exerciseGame = require("../../exercise-game");

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var actionSetScenario = function actionSetScenario(scenario) {
  return {
    payload: scenario,
    type: 'SET_SCENARIO'
  };
};

var actionSetPresentationBlocks = function actionSetPresentationBlocks(presentationBlocks) {
  return {
    payload: presentationBlocks,
    type: 'SET_SCENARIO_PRESENTATION_BLOCKS'
  };
};

var actionSetScenarioTemplate = function actionSetScenarioTemplate(config) {
  return {
    payload: config,
    type: 'SET_SCENARIO_TEMPLATE'
  };
};

exports.actionSetScenarioTemplate = actionSetScenarioTemplate;

function getScenario() {
  return (
    /*#__PURE__*/
    function () {
      var _ref2 = _asyncToGenerator(
      /*#__PURE__*/
      regeneratorRuntime.mark(function _callee(dispatch, getState, _ref) {
        var scenarioApi, _ref3, data, errors, options, _data$ppExerciseList, ppExerciseList, _data$ppSlideList, ppSlideList, otherData, presentationBlocks;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                scenarioApi = _ref.scenarioApi;
                _context.next = 3;
                return scenarioApi.getScenario();

              case 3:
                _ref3 = _context.sent;
                data = _ref3.data;
                errors = _ref3.errors;

                if (errors) {
                  _context.next = 17;
                  break;
                }

                options = data.options, _data$ppExerciseList = data.ppExerciseList, ppExerciseList = _data$ppExerciseList === void 0 ? {} : _data$ppExerciseList, _data$ppSlideList = data.ppSlideList, ppSlideList = _data$ppSlideList === void 0 ? {} : _data$ppSlideList, otherData = _objectWithoutProperties(data, ["options", "ppExerciseList", "ppSlideList"]);
                presentationBlocks = (0, _scenario.normPresentationBlocks)(ppExerciseList, ppSlideList);
                dispatch((0, _exerciseGame.actionSetExerciseList)((0, _exerciseGame.normExerciseList)(ppExerciseList)));
                dispatch((0, _exerciseGame.actionSetExerciseBlockList)((0, _exerciseGame.normExerciseBlockList)(ppExerciseList)));
                dispatch(actionSetScenario(otherData));
                dispatch(actionSetPresentationBlocks(presentationBlocks));
                dispatch(actionSetScenarioTemplate(options));
                return _context.abrupt("return", (0, _scenario.normScenario)(data));

              case 17:
                return _context.abrupt("return", errors);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function (_x, _x2, _x3) {
        return _ref2.apply(this, arguments);
      };
    }()
  );
}